<template>
  <div v-show="showcompareclose">
    <img
      @click="handlCompareClose"
      label="123"
      class="compare"
      :src="src"
      style="width: 40px; height: 40px"
    />
  </div>
</template>

<script>
import AddBar from "../../mapfunction/AddBar.js";
export default {
  name: "screenCompare",
  data() {
    return {
      text: "数据加载计算中,请等待",
      words: [{ text: "数据加载计算中,请等待", showcolor: false }],
      showcompareclose: false,
      src: require("../../../static/img/close.png"),
    };
  },
  methods: {
    handlCompareClose() {
      map3d_viewer.viewer.mouseHandlerManager.trigger("compareState", false);
      this.showcompareclose = false;
      this.words = [{ text: "数据加载计算中,请等待", showcolor: false }];
      AddBar.removeAll();
    },
  },
  mounted() {
    map3d_viewer.viewer.mouseHandlerManager.listen(
      "barAnimationStart",
      (config) => {
        if (config) {
          this.showcompareclose = true;
          AddBar.addBar();
        }
      }
    );
  },
};
</script>


<style scoped>
.compare {
  color: white;
  justify-content: center;
  position: absolute;
  left: 98%;
  cursor: pointer;
  top: 10%;
  height: 400px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  background: transparent;
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/barAnimation.vue